/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
import { l } from '@atproto/lex-schema';
const $nsid = 'com.atproto.repo.getRecord';
export { $nsid };
export const $params = /*#__PURE__*/ l.params({
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
    repo: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
});
export const $output = /*#__PURE__*/ l.jsonPayload({
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    value: /*#__PURE__*/ l.lexMap(),
});
/** Get a single record from a repository. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['RecordNotFound']);
export { main };
const $lxm = $nsid;
export { $lxm };
//# sourceMappingURL=getRecord.defs.js.map